import React, { useState, useEffect } from 'react';
import * as styles from './cursorSlider.module.scss';
import { MinMax } from '../../../utils/types';
import RedArrowBack from '../../../../static/redArrowBack.svg';

interface ICursorSliderProps {
  min: number;
  max: number;
  step?: number;
  onChange: (e: MinMax) => void;
}

export const CursorSlider = ({ min, max, step = 1, onChange }: ICursorSliderProps) => {
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);

  const minPos = ((minValue - min) / (max - min)) * 100;
  const maxPos = ((maxValue - min) / (max - min)) * 100;

  useEffect(() => {
    onChange({ min: minValue, max: maxValue });
  }, [minValue, maxValue]);

  const handleChange = () => {
    onChange({ min: minValue, max: maxValue });
  };

  const handleMinChange = (event) => {
    event.preventDefault();
    const tmpValue = parseFloat(event.target.value);
    const value = Number.isNaN(tmpValue) || tmpValue < 0 ? min : tmpValue;
    const newMinVal = Math.min(value, maxValue - step);
    setMinValue(newMinVal < 0 ? 0 : newMinVal);
  };
  const handleMaxChange = (event) => {
    event.preventDefault();
    const tmpValue = parseFloat(event.target.value);
    const value = Number.isNaN(tmpValue) || tmpValue < 0 ? min : tmpValue;
    const newMaxVal = Math.max(value, minValue + step);
    const res = newMaxVal > max ? max : newMaxVal;
    setMaxValue(res);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.inputWrapper}>
        <input
          id="min"
          className={styles.input}
          type="range"
          value={minValue}
          min={min}
          max={max}
          step={step}
          onChange={handleMinChange}
          onMouseUp={handleChange}
          onTouchEnd={handleChange}
        />
        <input
          id="max"
          className={styles.input}
          type="range"
          value={maxValue}
          min={min}
          max={max}
          step={step}
          onChange={handleMaxChange}
          onMouseUp={handleChange}
          onTouchEnd={handleChange}
        />
      </div>
      <div className={styles.controlWrapper}>
        <div className={`${styles.control} ${styles.min}`} style={{ left: `${minPos}%` }}>
          <RedArrowBack />
        </div>
        <div className={styles.rail}>
          <div
            className={styles.innerRail}
            style={{ left: `${minPos}%`, right: `${100 - maxPos}%` }}
          />
        </div>
        <div className={`${styles.control} ${styles.max}`} style={{ left: `${maxPos}%` }}>
          <RedArrowBack />
        </div>
      </div>
      <div className={styles.inputsWrapper}>
        <input value={minValue} onChange={handleMinChange} />
        <span>-</span>
        <input value={maxValue} onChange={handleMaxChange} />
      </div>
    </div>
  );
};
